import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

export class Tnc extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.tnc.title">使用條款</Translate>
              </h1>
              <p>
                <span className="text-danger">
                  <Translate contentKey="static.tnc.text1">
                    一經PATO ENTERTAINMENT 成功訂購門票，即代表同意及接受 PATO ENTERTAINMENT 訂立的所有使用條款，
                  </Translate>
                </span>
                <Translate contentKey="static.tnc.text2">請於訂購前細心閱讀以下條款。PATO ENTERTAINMENT有權隨時更改任何條款。</Translate>
              </p>
              <ul>
                <li>
                  <Translate contentKey="static.tnc.p1">門票數量有限，售完即止。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p2">一人一票入場。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p3">除有關活動／演出／表演延期外，訂單一經確認，恕不能取消、轉換或退款。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p4">持票人只可在門票所述的日期進場，並按門票所述位置或座位就座。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p5">門票如有遺失，將一律不獲補發。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p6">節目如因事故取消，主辦機構將保留退票或改期之權利。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p7">節目如有更改，將由主辦機構決定。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p8">
                    網上購票手續費為電子票每張門票HK$10。成功購買門票後，閣下將會收到電郵提供有關之電子票二維碼。
                  </Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p9">成功購買門票後會收到確認郵件。</Translate>
                </li>
                <li>
                  <Translate contentKey="static.tnc.p10">
                    如有查詢，歡迎電郵至 <a href='mailto:cs@patotix.com'>cs@patotix.com</a>，或於辦公時間 (星期一至五,上午10時至下午5時) WhatsApp
                    <a href='https://wa.me/+85256676376'>+852 5667 6376</a> 與我們聯絡。
                  </Translate>
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default Tnc;
